const { ThematicPackageStatus } = require("./thematic-package-status-enum");
const { roles } = require("./roles");

const thematicPackageStatuses = [
  {
    tag: ThematicPackageStatus.FIRST_SCIENTIFIC_CHECK,
    name: 'New thematic package',
    description: 'Check basic information associated with the created thematic package',
    emailTemplate: 'Thematic_Package_Creation_Molecular_Biologist_Notification',
    notApprovedEmailTemplate: 'Package_PRS_SNPS_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
    nextApprovalStatus: ThematicPackageStatus.SECOND_SCIENTIFIC_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.FIRST_SCIENTIFIC_CHECK
  },
  {
    tag: ThematicPackageStatus.SECOND_SCIENTIFIC_CHECK,
    name: 'Scientific department check',
    description: 'Check the traits of the thematic package, disable unwanted association reports.',
    emailTemplate: 'Thematic_Package_Scientific_Update',
    notApprovedEmailTemplate: 'Package_PRS_SNPS_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
    ],
    nextApprovalStatus: ThematicPackageStatus.FINAL_MOLECULAR_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.FIRST_SCIENTIFIC_CHECK
  },
  {
    tag: ThematicPackageStatus.FINAL_MOLECULAR_CHECK,
    name: 'Biology department check',
    description: 'Final scientific approval from Molecular biologist with or without additional changes.',
    emailTemplate: 'Thematic_Package_Molecular_Biologist_Final_Update',
    notApprovedEmailTemplate: 'Package_Analysis_Not_Approved_Template',
    // emailTemplate: 'Thematic_Package_Molecular_Biologist_Final',
    // emailTemplateNotApproved: 'Package_Analysis_Not_approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
    ],
    nextApprovalStatus: ThematicPackageStatus.ANALYSIS_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.FIRST_SCIENTIFIC_CHECK
  },
  {
    tag: ThematicPackageStatus.ANALYSIS_CHECK,
    name: 'Analytics department check',
    description: 'Run EDAG simulation and approve traits versions.',
    emailTemplate: 'Package_PRS_SNPS_Approved_Template',
    notApprovedEmailTemplate: 'Package_Deploy_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.ANALYTICS_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus: ThematicPackageStatus.REPORT_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.FINAL_MOLECULAR_CHECK
  },
  // ThematicPackageStatus.SCIENTIFIC_TEXTS_CREATION & ThematicPackageStatus.REPORT_CHECK must be 1 situation
  // {
  //   tag: ThematicPackageStatus.SCIENTIFIC_TEXTS_CREATION,
  //   name: 'Scientific Notification for Analytics Approval',
  //   description: 'Permission is granted from scientists to create texts for all traits that are associated with the specific thematic package.',
  //   emailTemplate: 'Package_Report_Texts_Notification',
  //   notApprovedEmailTemplate: 'Package_Report_Quality_Approved_Template',
  //   // emailTemplate: 'Package_Report_Texts_Notification',
  //   proceedPermissionRoles: [
  //     roles.ADMINISTRATOR_ROLE,
  //     roles.SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE,
  //     roles.SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE,
  //     roles.SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE,
  //     roles.SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE,
  //     roles.SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE,
  //   ],
  //   nextApprovalStatus:  ThematicPackageStatus.REPORT_CHECK,
  //   notApprovedNextApprovalStatus: ThematicPackageStatus.ANALYSIS_CHECK
  // },
  {
    tag: ThematicPackageStatus.REPORT_CHECK,
    name: 'Report template creation',
    description: 'Upload traits texts in order and thematic package assets in order to be everything ready to produce report.',
    emailTemplate: 'Package_Report_Template_Creation',
    notApprovedEmailTemplate: 'Package_Quality_Not_Approved_Template',
    // emailTemplate: 'Package_Report_Template_Creation',
    // emailTemplateNotApproved: 'Report_Quality_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus:  ThematicPackageStatus.QUALITY_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.ANALYSIS_CHECK
  },
  {
    tag: ThematicPackageStatus.QUALITY_CHECK,
    name: 'Quality Check',
    description: 'Report is completed, quality check is demanded.',
    emailTemplate: 'Package_Report_Creation',
    notApprovedEmailTemplate: 'Package_Deploy_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.QUALITY_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus:  ThematicPackageStatus.COMMERCIAL_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.REPORT_CHECK
  },
  {
    tag: ThematicPackageStatus.COMMERCIAL_CHECK,
    name: 'Commercial Check',
    description: 'Quality check has been ended, commercial check is demanded.',
    emailTemplate: 'Package_Report_Quality_Approved_Template',
    notApprovedEmailTemplate: 'Package_Management_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus:  ThematicPackageStatus.MANAGEMENT_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.QUALITY_CHECK
  },
  {
    tag: ThematicPackageStatus.MANAGEMENT_CHECK,
    name: 'Management Check',
    description: 'Commercial check has been ended, management check is demanded.',
    emailTemplate: 'Package_Report_Submitted_Template',
    notApprovedEmailTemplate: 'Package_Deploy_Not_Approved_Template',
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.MANAGEMENT_ROLE,
    ],
    nextApprovalStatus:  ThematicPackageStatus.DEPLOY_CHECK,
    notApprovedNextApprovalStatus: ThematicPackageStatus.COMMERCIAL_CHECK
  },
  {
    tag: ThematicPackageStatus.DEPLOY_CHECK,
    name: 'Eshop Deploy',
    description: 'Thematic Package approval steps have been completed, deploy check is demanded.',
    emailTemplate: 'Package_Report_Enabled_Template',
    notApprovedEmailTemplate: null,
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus:  ThematicPackageStatus.FINAL,
    notApprovedNextApprovalStatus: ThematicPackageStatus.MANAGEMENT_CHECK
  },
  // {
  //   tag: ThematicPackageStatus.PRODUCT,
  //   name: 'Product Creation',
  //   description: 'The product has now been created in eshop.',
  //   emailTemplate: null,
  //   notApprovedEmailTemplate: null,
  //   proceedPermissionRoles: [
  //     roles.ADMINISTRATOR_ROLE,
  //     roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
  //   ],
  //   nextApprovalStatus:  ThematicPackageStatus.FINAL,
  //   notApprovedNextApprovalStatus: ThematicPackageStatus.DEPLOY_CHECK
  // },
  {
    tag: ThematicPackageStatus.FINAL,
    name: 'Finalization',
    description: 'This is the last step. The thematic package has been deployed. Proceed and terminate the roadmap flow.',
    emailTemplate: 'Thematic_Package_Final_Template',
    notApprovedEmailTemplate: null,
    proceedPermissionRoles: [
      roles.ADMINISTRATOR_ROLE,
      roles.COMMERCIAL_DEPARTMENT_USER_ROLE,
    ],
    nextApprovalStatus:  null,
    notApprovedNextApprovalStatus: null
  }
];

module.exports = {thematicPackageStatuses};
